export enum VoucherStatusEnum {
  Pending = 'Pending',
  Applied = 'Applied',
  Canceled = 'Canceled',
}